<template>
  <v-content style="height: 100%">
    <v-container fill-height fluid style="height: 100%">
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12 ma-auto">
            <v-toolbar color="general">
              <v-toolbar-title>Shop - Panel</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  ref="username"
                  v-model="username"
                  :rules="[() => !!username || 'This field is required']"
                  prepend-icon="mdi-account"
                  label="Login"
                  placeholder="max.mustermann@gmail.com"
                  required
                />
                <v-text-field
                  ref="password"
                  v-model="password"
                  :rules="[() => !!password || 'This field is required']"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showPassword ? 'text' : 'password'"
                  prepend-icon="mdi-lock"
                  label="Password"
                  placeholder="*********"
                  required
                  @keydown.enter="login"
                  @click:append="showPassword = !showPassword"
                />
              </v-form>
            </v-card-text>
            <v-divider class="mt-5" />
            <v-card-actions>
              <v-spacer />
              <v-btn align-center justify-center color="general" @click="login" :disabled="loading">
                <span v-if="!loading">Anmelden</span>
                <v-progress-circular v-if="loading" indeterminate></v-progress-circular>
              </v-btn>
            </v-card-actions>
            <v-snackbar v-model="snackbar" :color="color" :top="true">
              {{ errorMessages }}
              <v-btn dark flat @click="snackbar = false">
                Schließen
              </v-btn>
            </v-snackbar>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data: function() {
    return {
      username: '',
      password: '',
      errorMessages: 'Incorrect login info',
      snackbar: false,
      loading: false,
      color: 'general',
      showPassword: false
    }
  },

  // Sends action to Vuex that will log you in and redirect to the dash otherwise, error
  methods: {
    login: function() {
      this.loading = true
      console.log(this.username)
      this.$store
        .dispatch('login', { username: this.username, password: this.password })
        .then(() => {
          this.loading = false
          this.$router.push('/dashboard')
        })
        .catch(err => {
          console.log(err)
          this.errorMessages = err
          this.loading = false
          this.snackbar = true
        })
    }
  },
  metaInfo() {
    return {
      title: 'Super Secret | Login'
    }
  }
}
</script>
